import { useCallback } from 'react';

// eslint-disable-next-line no-restricted-imports
import { useLegalClientSaveSourcesOfIncomeMutation } from 'api/generated/graphql';
import { useError } from 'api/helpers';
import { LegalClientSaveSourcesOfIncomeParam } from 'api/types/params';

import {
  parseLegalClient,
  parseLegalClientSaveSourcesOfIncomeParam,
} from './helpers';

export const useLegalClientSaveSourcesOfIncome = () => {
  const [saveSourcesOfIncome, { data, loading, error: apolloError }] =
    useLegalClientSaveSourcesOfIncomeMutation();

  const error = useError(apolloError);

  return {
    data: data?.legalClientSaveSourcesOfIncome
      ? parseLegalClient(data.legalClientSaveSourcesOfIncome)
      : undefined,
    loading,
    error,
    saveSourcesOfIncome: useCallback(
      async (id: string, params: LegalClientSaveSourcesOfIncomeParam) => {
        const res = await saveSourcesOfIncome({
          variables: {
            id,
            input: parseLegalClientSaveSourcesOfIncomeParam(params),
          },
        });

        return res.data?.legalClientSaveSourcesOfIncome
          ? parseLegalClient(res.data.legalClientSaveSourcesOfIncome)
          : undefined;
      },
      [saveSourcesOfIncome]
    ),
  };
};
